

import { XIcon } from '@heroicons/react/outline';
import * as React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/lib/auth';
import Icon8 from '@/assets/img/pay.png';
import '../../styles/New-index.scss';
import '../../styles/dashboard.scss';
import '../../styles/New-responsive.scss';
import './MainLayout.scss';
import moment from 'moment';
import { ReactComponent as FullLogo } from '../../assets/full-logo.svg';

import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { ReactComponent as ContactIcon } from '../../assets/steam/contactBlack.svg';
import { ReactComponent as InstituteIcoon } from '../../assets/steam/instituteBlack.svg';
import { ReactComponent as UserIconBlack } from '../../assets/steam/user-black.svg';
import { ReactComponent as LocationIcon } from '../../assets/steam/location.svg';
import { ReactComponent as ProductIcoon } from '../../assets/steam/products-icon.svg';
import { ReactComponent as FunnelIcoon } from '../../assets/steam/funnel.svg';
import { ReactComponent as QuoteIcoon } from '../../assets/steam/quotes.svg';
import TYPES from '@/utils/constants';

type SideNavigationItem = {
  name: string;
  to: string;
  icon: any;
};

const SideNavigation = ({ sidebarOpen, setSidebarOpen }: MobileSidebarProps) => {
  const location = useLocation();
  const { logout, user } = useAuth();


  let navigation: any = [];

  // navigation = ([
  //   { name: 'Funnel List', to: './funnel', icon: Icon8 },
  //   { name: 'User Profiles', to: './users', icon: Icon8 },
  //   { name: 'Products', to: './products', icon: Icon8 },
  //   { name: 'Institute List', to: './institutes', icon: Icon8 },
  //   { name: 'Contacts', to: './contacts', icon: Icon8 },
  //   { name: 'Locations', to: './location', icon: Icon8 },
  // ].filter(Boolean) as SideNavigationItem[])

  if (
    user && user.userRoleId === TYPES.SUPER_ADMIN.toString()
  ) {
    
  navigation = ([
    { name: 'Funnels', to: './funnel', icon: Icon8 },
    { name: 'Users', to: './users', icon: Icon8 },
    { name: 'Products', to: './products', icon: Icon8 },
    { name: 'Institutes', to: './institutes', icon: Icon8 },
    { name: 'Contacts', to: './contacts', icon: Icon8 },
    { name: 'Locations', to: './location', icon: Icon8 },
  ].filter(Boolean) as SideNavigationItem[])

  } else if(  user && user.userRoleId === TYPES.MARKETING.toString()){
    navigation = ([
      { name: 'Funnels', to: './funnel', icon: Icon8 },
      { name: 'Institutes', to: './institutes', icon: Icon8 },
      { name: 'Contacts', to: './contacts', icon: Icon8 },
      { name: 'Quotes', to: './quotes', icon: Icon8 },
    ].filter(Boolean) as SideNavigationItem[])
  }else if( user && user.userRoleId === TYPES.ACCOUNTS.toString()){
    navigation = ([
      { name: 'Claims', to: './claim', icon: Icon8 },
    ].filter(Boolean) as SideNavigationItem[])
  }




  return (
    <div className="main-menu-outer">
      <div className="menu-parent-class">
        <FullLogo className='full-logo-sidebar' />
        <nav aria-label="Main Nav" className=" flex flex-col space-y-1 update-menu-ui">

          {navigation.map((item: any, index: number) => (
            <Link
              key={index}
              to={item.to}
              onClick={() => {
                setSidebarOpen(false);
              }}
              className={`side-menu-item flex items-center rounded-lg bg-gray-100 px-2 py-2 text-gray-700 anchor-btm ${location.pathname == item.to.substring(1) ||
                  (location.pathname === '/' && item.name === 'Schedule')
                  ? 'active'
                  : ''
                }`}
            >
              {item.name === 'Funnels' && <FunnelIcoon/>}
              {item.name === 'Users' && <UserIconBlack />}
              {item.name === 'Products' && <ProductIcoon />}
              {item.name === 'Institutes' && <InstituteIcoon />}
              {item.name === 'Contacts' && <ContactIcon />}
              {item.name === 'Locations' && <LocationIcon />}

              {item.name === 'Claims' && <QuoteIcoon />}
              {item.name === 'Quotes' && <QuoteIcoon />}

              <span className="menu-name">{item.name}</span>
            </Link>
          ))}
        </nav>
      </div>
      <div className="sticky inset-x-0 bottom-0">

      </div>
    </div>
  );
};

type MobileSidebarProps = {
  onNavigate: () => void;
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};


const Sidebar = ({ sidebarOpen, setSidebarOpen, onNavigate }: MobileSidebarProps) => {
  const { user, logout} = useAuth();
  //console.log("sdasdas", sidebarOpen)

  return (
    <div className="sidebar-desktop flex-shrink-0">
      <div className="flex flex-col w-sidebar">
        <div className="flex flex-col h-0 flex-1">
          {/* <Logo onNavigate={onNavigate}></Logo> */}
          <div className="flex-1 flex flex-col">
            <nav className="flex-1">
              <div className="flex flex-col justify-between custom-sidebar">
                <>
                  <SideNavigation
                    sidebarOpen={sidebarOpen}
                    onNavigate={onNavigate}
                    setSidebarOpen={setSidebarOpen}
                  />

                  {user &&
                    <div className="subscription-details">
                      <div className="users-container">
                        <div>
                          <InitialsAvatar name={user && user.name ? user.name : 'SA'} className="avatar padding" />
                        </div>
                        <div className="user-details-container">

                          <div className="user-tab-name">
                            <div className="name">{user?.name}</div>
                          </div>
                        </div>
                      </div>


                      <button className='steam-button button-no-bg-stroke' onClick={()=>{logout()}}>Logout</button>
                    </div>
                  }

                </>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

type MainLayoutProps = {
  children: React.ReactNode;
};
export const MainLayout = ({ children }: MainLayoutProps) => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [dinnerHeight, setInnerHeight] = React.useState(window.innerHeight);
  const navigate = useNavigate();
  const handleResize = () => {
    setInnerHeight(window.innerHeight);
  };
  const { user } = useAuth();
  React.useEffect(() => {
    // set resize listener
    window.addEventListener('resize', handleResize);

    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const subscription = true;
  //console.log("showSideBar",location.pathname, user?.name )
  const showSideBar =  location.pathname === '/login' ? false : (location.pathname === '/' && !user ) ? false :  true;
  return (
    <div className="main-layout h-screen-min overflow-hidden" style={{ minHeight: dinnerHeight }}>

      <div className="flex bottom-section ">
        <>
          {/* <MobileSidebar
              onNavigate={() => {
                navigate('/');
              }}
              sidebarOpen={sidebarOpen}
              setSidebarOpen={setSidebarOpen}
            /> */}
          {showSideBar&& <Sidebar
            onNavigate={() => {
              navigate('/');
            }}
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
          />}
        </>

        <div className="flex flex-col w-0 flex-1 overflow-hidden layout-outer">
          <main className={`flex-1 relative focus:outline-none content-section ${location.pathname === '/login' ? "hide-overflow" : ''}`}>{children}</main>
        </div>
      </div>
    </div>
  );
};
